module.exports = __webpack_public_path__ + "img/tz.7feb5df0.svg";